import { useSearchParams } from 'react-router-dom';
import { CategoryRolesStrip } from './components/CategoryRolesStrip';
import { DigestPanel } from './components/DigestPanel';
import { DoctoralRail } from './components/DoctoralRail';
import { FeedPanel } from './components/FeedPanel';
import { HeroSection } from './components/HeroSection';
import { HeroSlider } from './components/HeroSlider';
import { HomeDashboard } from './components/HomeDashboard';
import { NewsTicker } from './components/NewsTicker';
import { PendingBand } from './components/PendingBand';
import { PopularHashtagsStrip } from './components/PopularHashtagsStrip';
import { ScienceBand } from './components/ScienceBand';
import { MegaNav } from '@/components/layout/MegaNav';
import { useAuth } from '@/hooks/useAuth';
import { useShell } from '@/hooks/useShell';
import { canShowActiveDoctoralPanel } from '@/lib/activeDoctoralPanel';

/** Full home scroll order — Task 14 (1.83):
 * Hero+Core → MegaNav → Categories/Roles → Urgent → Hashtags →
 * Work feed + Banner + Digest(/Doctoral) → Pending → Science band → Q&A|Core|Support.
 * No role-cabinet rails on home.
 */
const HomePage = () => {
  const { user } = useAuth();
  const { shell } = useShell();
  const [params] = useSearchParams();
  const preview = params.get('as') || params.get('preview');
  const fromCapability = shell?.capabilities?.home?.activeDoctoralPanel;
  const isOwner =
    user?.activeRole === 'SYSTEM_OWNER' ||
    (Array.isArray(user?.roles) && user.roles.includes('SYSTEM_OWNER'));
  // Capability is the hard gate; owner ?as= / ?preview= may still force the panel.
  const showDoctoral =
    typeof fromCapability === 'boolean'
      ? fromCapability || (Boolean(isOwner && preview) && canShowActiveDoctoralPanel(user, preview))
      : canShowActiveDoctoralPanel(user, preview);

  return (
    <>
      <HeroSection />
      <MegaNav />
      <CategoryRolesStrip />
      <NewsTicker />
      <PopularHashtagsStrip />
      <section className={`news-stage${showDoctoral ? ' news-stage--with-rail' : ''}`}>
        <FeedPanel />
        <HeroSlider />
        {showDoctoral ? (
          <div className="news-stage-right">
            <DigestPanel />
            <DoctoralRail />
          </div>
        ) : (
          <DigestPanel />
        )}
      </section>
      <PendingBand />
      <ScienceBand />
      <HomeDashboard />
    </>
  );
};

export default HomePage;
